import { render, staticRenderFns } from "./Design3.vue?vue&type=template&id=481cb96d&scoped=true"
import script from "./Design3.vue?vue&type=script&lang=js"
export * from "./Design3.vue?vue&type=script&lang=js"
import style0 from "./Design3.vue?vue&type=style&index=0&id=481cb96d&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "481cb96d",
  null
  
)

export default component.exports